var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-cell',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("dictFilter")(_vm.value,_vm.options)))])])}
var staticRenderFns = []

export { render, staticRenderFns }